<template>
  <div>
    <el-table :data="auditList" height="900">
      <el-table-column prop="id" label="订单id" width="200"></el-table-column>
      <el-table-column label="创建时间" width="200">
        <template slot-scope="scope">{{ scope.row.createdTime | moment }}</template>
      </el-table-column>

      <el-table-column prop="userId" label="用户Id" width="80"></el-table-column>
      <el-table-column prop="txCoin" label="币种" width="80"></el-table-column>
      <el-table-column prop="chain" label="币种链" width="80"></el-table-column>
      <el-table-column prop="txToWallet" label="转入钱包地址" width="300"></el-table-column>
      <el-table-column prop="txNetworkLink" label="hash" width="300">
        <template slot-scope="scope">
          <a :href="scope.row.txNetworkLink" target="_blank">
            {{ scope.row.txNetworkLink }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="txType" label="充值类型">
        <template slot-scope="scope">
          <span v-if="scope.row.txType === 1">充值</span>
          <span v-else-if="scope.row.txType === -2">内部转入</span>
        </template>
      </el-table-column>
      <el-table-column prop="txAmount" label="数量" width="80"></el-table-column>
      <!-- <el-table-column prop="gas" label="gas"></el-table-column>
      <el-table-column prop="nonce" label="nonce"></el-table-column> -->
      <!-- <el-table-column prop="result" label="result">
        <template slot-scope="scope">{{scope.row.result+''}}</template>
      </el-table-column> -->
      <el-table-column prop="txDepositDesc" label="状态" width="140">
        <template slot-scope="scope">{{ scope.row.txDepositDesc }}</template>
      </el-table-column>
    </el-table>
    <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="handleCurrentChange">
    </pagination>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";

export default {
  name: "KYCAudit",
  data() {
    return {
      auditId: null
    };
  },
  computed: {
    ...mapState("depositeRecord", ["pagination", "totalCount", "auditList"])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations("depositeRecord", ["setpage"]),
    handleCurrentChange(pagination) {
      console.log('page', pagination);
      this.setpage(pagination);
      this.$emit("refresh", { pagination, type: 1 });
    }
  }
};
</script>

<style lang="less" scoped></style>
